import { Nullable } from '@ps/utils';
import {
  BuyerAccessLevelOption,
  isMultiBuyerManagerOption,
} from '../models/access-level-option.model';
import { MultiBuyerEntity } from '../models/multi-buyer-entity.model';
import { UserCompanyDetail } from '../models/user-company.model';
import {
  MULTI_BUYER_MANAGER_ACCESS_LEVEL,
  MULTI_BUYER_MASTER_ACCESS_LEVEL,
  MULTI_BUYER_PM_ACCESS_LEVEL,
  STANDARD_BUYER_ACCESS_LEVELS,
} from '../user.constants';

const MULTI_BUYER_CANDIDATES: readonly BuyerAccessLevelOption[] = [
  MULTI_BUYER_PM_ACCESS_LEVEL,
  MULTI_BUYER_MASTER_ACCESS_LEVEL,
  MULTI_BUYER_MANAGER_ACCESS_LEVEL,
];

/** Falls back to MultiBuyer PM when the company configures none. */
export const multiBuyerAccessLevelOptions = (
  company: UserCompanyDetail,
): BuyerAccessLevelOption[] => {
  const configured = MULTI_BUYER_CANDIDATES.filter((candidate) =>
    company.multiBuyerAccessLevels.some((companyAccessLevel) =>
      isMultiBuyerManagerOption(candidate)
        ? companyAccessLevel.isMultiBuyerManager
        : companyAccessLevel.buyerAccessLevel === candidate.value,
    ),
  );

  return configured.length ? configured : [MULTI_BUYER_PM_ACCESS_LEVEL];
};

/** A Service Partner entity is restricted to MultiBuyer Manager. */
export const buyerAccessLevelOptions = (
  company: UserCompanyDetail,
  primaryEntity: Nullable<MultiBuyerEntity>,
): BuyerAccessLevelOption[] => {
  if (!company.multiBuyerEntityIds.length) {
    return [...STANDARD_BUYER_ACCESS_LEVELS];
  }

  const multiBuyerOptions = multiBuyerAccessLevelOptions(company);
  const isServicePartnerEntity =
    !!primaryEntity &&
    company.multiBuyerServicePartnerIds.includes(primaryEntity.id);

  if (!isServicePartnerEntity) {
    return multiBuyerOptions;
  }

  const managerOnly = multiBuyerOptions.filter(isMultiBuyerManagerOption);
  return managerOnly.length ? managerOnly : multiBuyerOptions;
};
